import { render, staticRenderFns } from "./AlterDetail.vue?vue&type=template&id=07966959&scoped=true"
import script from "./AlterDetail.vue?vue&type=script&lang=js"
export * from "./AlterDetail.vue?vue&type=script&lang=js"
import style0 from "./AlterDetail.vue?vue&type=style&index=0&id=07966959&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07966959",
  null
  
)

export default component.exports